// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"720":"00d4b5a2","787":"3058b895","860":"8b8fc95a"}[chunkId] + ".chunk.js";
};